import React, { useState, Suspense } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { CSpinner } from '@coreui/react'

// routes config
import routesSitios from '../routesSitios'
const basePath = String(process.env.PUBLIC_URL).trim()

const AppContentSitio = (props) => {
  const { sitio } = props
  const [rutas, setRutas] = useState([])
  const dispatch = useDispatch()
  routesSitios.then((response) => {
    setRutas(response)
  })

  return (
    <Suspense fallback={<CSpinner color="primary" />}>
      <Switch>
        {rutas.map((route, idx) => {
          dispatch({
            type: 'set',
            sitiosStore: rutas.filter((aux) => {
              return aux.to.search('/inicio') >= 0
            }),
          })
          return (
            route.component && (
              <Route
                key={idx}
                path={route.to}
                exact={route.exact}
                name={route.name}
                render={(props) => (
                  <>
                    <route.component {...props} sitio={sitio} />
                  </>
                )}
              />
            )
          )
        })}
        {setTimeout(() => {
          return <Redirect from={basePath + `/${sitio}`} to={basePath + `/${sitio}/inicio`} />
        }, 0)}
      </Switch>
    </Suspense>
  )
}

AppContentSitio.propTypes = {
  sitio: PropTypes.string.isRequired,
}

export default React.memo(AppContentSitio)
